module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/4@2x_9394f3b23e530d30a4f94e55eda7d816.png";